import { createContext } from 'react'
//Appointment details for shipping purposes
const appointmentContext = createContext()

export default appointmentContext
